import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '@app/models';
import { AuthApi } from '../api/services/auth.api';
import {
  ACCESS_TOKEN_NAME,
  CURRENT_USER_IN_LOCKAL_STORAGE,
} from '../../common/constants/auth.constants';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient, private readonly authApi: AuthApi) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(
        localStorage.getItem(CURRENT_USER_IN_LOCKAL_STORAGE) as string,
      ) as User,
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  async login(email: string, password: string) {
    const { [ACCESS_TOKEN_NAME]: accessToken, user } = await this.authApi.login(
      email,
      password,
    );
    localStorage.setItem(ACCESS_TOKEN_NAME, accessToken);
    localStorage.setItem(CURRENT_USER_IN_LOCKAL_STORAGE, JSON.stringify(user));
    this.currentUserSubject.next(user);
    return user;
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem(ACCESS_TOKEN_NAME);
    localStorage.removeItem(CURRENT_USER_IN_LOCKAL_STORAGE);
    this.currentUserSubject.next(null);
  }
}
